import { render } from "./ContactFormular.vue?vue&type=template&id=cc3e4500&scoped=true&ts=true"
import script from "./ContactFormular.ts?vue&type=script&lang=ts"
export * from "./ContactFormular.ts?vue&type=script&lang=ts"

import "./ContactFormular.vue?vue&type=style&index=0&id=cc3e4500&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3e4500"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSelect,QInput,QBtn});
